export const PATHS = {
  dashboard: "/dashboard",
  dashboardDetail: "/dashboard-detail",
  createTicket: "/create-ticket",
  createFacilityTickets: "/create-ticket/facilities",
  createCustomerComplaint: "/create-ticket/customer-complaint",
  createRemoteSupportRequest: "/create-ticket/remote-support",
  createCustomerService: "/create-ticket/customer-service",
  createEtisalatThirdParty: "/create-ticket/etisalat-third-party",
  createUnusualEvent: "/create-ticket/unusual-event",
  bulkOperation: "/bulk-operations",
  createBulkTicket: "/create-ticket/bulk",
  closeBulkTicket: "/close-ticket/bulk",
  closeBulkCashTicket: "/close-tickets/cash/bulk",
  openTickets: "/open-tickets",
  assignedTickets: "/assigned-tickets",
  cashTickets: "/cash-tickets",
  vaultAccessTickets: "/vault-access-tickets",
  closedTickets: "/closed-tickets",
  cancelledTickets: "/cancelled-tickets",
  awaitingTickets: "/awaiting-tickets",
  resolvedTickets: "/resolved-awaiting",
  allTickets: "/all-tickets",
  gunnebo: "/gunnebo-tickets",
  nonGunnebo: "/non-gunnebo-tickets",
  ticketDetails: "/ticket-details",
  taskDetails: "/task-details",
  jobCards: "/job-cards",
  routesManagement: "/routes-management",
  selfAssignedTickets: "/self-assigned-tickets",
  changePassword: "/change-password",
  profile: "/profile",
  reports: "/reports",
  allCalls: "/all-calls",
  openCalls: "/open-calls",
  cashCalls: "/cash-calls",
  assignedCalls: "/assigned-calls",
  resolvedCalls: "/resolved-calls",
  closedCalls: "/closed-calls",
  cancelledCalls: "/cancelled-calls",
  myCalls: "/self-calls",
  allServiceAndNonServiceCalls: "/all-service-non-service-calls",
};
